<template>
    <div>
        <g-loader v-if="useCreatorStore().loadingLiveUrls" data-testid="live-urls-loading" />
        <div v-else>
            <slot />

            <g-typography v-if="isPage" class="g-mb-6" tag="h1" font-weight="semibold" value="Brands" />

            <brand-switcher-item
                v-for="(liveUrl, i) in useCreatorStore().data.liveUrls"
                :key="i"
                class="g-mb-5"
                :display-name="formatBrandNames(liveUrl)"
                :current="isCurrentAccount(liveUrl)"
                @switch="handleSwitch(liveUrl)"
            />
        </div>
    </div>
</template>

<script>
    import { message } from '@grininc/grin-ui';
    import useHttp from '../../../../composables/use-http';
    import useLiveSiteSwitcher from '../../../../composables/use-live-site-switcher';
    import useEventTracking from '../../../../composables/use-event-tracking';
    import { useContactStore, useCreatorStore } from '../../../../../stores';
    import { EVENT_NAME_LIVE_SITE_SWITCHER_COMPLETED } from '../../../../../app-v2/constants/analytics-events';
    import BrandSwitcherItem from './BrandSwitcherItem.vue';

    export default {
        name: 'SettingsBrands',
        components: { BrandSwitcherItem },

        props: {
            isPage: {
                type: Boolean,
                default: true
            }
        },

        setup() {
            const { getCurrentAccount, isCurrentAccount, formatBrandNames } = useLiveSiteSwitcher();

            const handleSwitch = (liveUrl) => {
                const { http } = useHttp();
                http.get(`/creator/switch-live-sites/${liveUrl.brands[0].account_id}`, {
                    params: {
                        brand: formatBrandNames(liveUrl)
                    }
                })
                    .then((res) => {
                        if (res?.body?.url) {
                            useEventTracking().trackEvent(EVENT_NAME_LIVE_SITE_SWITCHER_COMPLETED, {
                                contact_id: useContactStore().data?.id,
                                from_account: getCurrentAccount.value?.brands[0]?.account_id,
                                to_account: liveUrl?.brands[0]?.account_id
                            });

                            window.location = res?.body?.url;
                        } else {
                            message.error(`Failed to switch to ${formatBrandNames(liveUrl)}.`);
                        }
                    })
                    .catch(() => {
                        message.error(`Failed to switch to ${formatBrandNames(liveUrl)}.`);
                    });
            };

            return {
                useCreatorStore,
                isCurrentAccount,
                formatBrandNames,
                handleSwitch
            };
        }
    };
</script>
